import { all } from 'redux-saga/effects';

import appSagas from 'modules/app/sagas';
import chatSagas from 'modules/chat/sagas';
import intlSagas from 'modules/app/intl/sagas';
import worksSagas from 'modules/works/sagas';
import entitySagas from 'modules/entity/sagas';
import mediaSagas from 'modules/media/sagas';
import customersSagas from 'modules/customers/sagas';
import customizeSagas from 'modules/entity/subEntities/customize/sagas';
import websocketsSagas from 'modules/websockets/sagas';
import notificationsSagas from 'modules/notifications/sagas';
import appointmentSagas from 'modules/entity/subEntities/appointment/sagas';
import interventionSagas from 'modules/entity/subEntities/intervention/sagas';

export default function* rootSaga() {
  yield all([
    appSagas(),
    appointmentSagas(),
    chatSagas(),
    customersSagas(),
    customizeSagas(),
    entitySagas(),
    interventionSagas(),
    intlSagas(),
    mediaSagas(),
    notificationsSagas(),
    websocketsSagas(),
    worksSagas(),
  ]);
}
